// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@/shared/fonts/TT-Hoves-Pro-Trial-Thin.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("@/shared/fonts/TT-Hoves-Pro-Trial-ExtraLight.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("@/shared/fonts/TT-Hoves-Pro-Trial-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("@/shared/fonts/TT-Hoves-Pro-Trial-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("@/shared/fonts/TT-Hoves-Pro-Trial-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("@/shared/fonts/TT-Hoves-Pro-Trial-DemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("@/shared/fonts/TT-Hoves-Pro-Trial-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("@/shared/fonts/TT-Hoves-Pro-Trial-ExtraBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("@/shared/fonts/TT-Hoves-Pro-Trial-Black.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("@/shared/fonts/CeraPro-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("@/shared/fonts/CeraPro-Black.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'TT Hoves Pro Trial';
    font-style: normal;
    font-weight: 100;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff');
}
@font-face {
    font-family: 'TT Hoves Pro Trial';
    font-style: normal;
    font-weight: 200;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
}

@font-face {
    font-family: 'TT Hoves Pro Trial';
    font-style: normal;
    font-weight: 300;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff');
}

@font-face {
    font-family: 'TT Hoves Pro Trial';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff');
}

@font-face {
    font-family: 'TT Hoves Pro Trial';
    font-style: normal;
    font-weight: 500;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff');
}

@font-face {
    font-family: 'TT Hoves Pro Trial';
    font-style: normal;
    font-weight: 600;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff');
}

@font-face {
    font-family: 'TT Hoves Pro Trial';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff');
}

@font-face {
    font-family: 'TT Hoves Pro Trial';
    font-style: normal;
    font-weight: 800;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff');
}

@font-face {
    font-family: 'TT Hoves Pro Trial';
    font-style: normal;
    font-weight: 900;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('woff');
}


@font-face {
    font-family: 'CeraPro';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('woff');
}

@font-face {
    font-family: 'CeraPro';
    font-style: normal;
    font-weight: 900;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('woff');
}

*{
    box-sizing: border-box;
    -webkit-touch-callout: none;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    -ms-overflow-style: none;
}
*::-webkit-scrollbar{
    width: 0;
}

body {
    margin: 0;
    font-family: 'TT Hoves Pro Trial', sans-serif;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,2DAAsE;AAC1E;AACA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,2DAA4E;AAChF;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,2DAAuE;AAC3E;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,2DAAyE;AAC7E;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,2DAAwE;AAC5E;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,2DAA0E;AAC9E;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,2DAAsE;AAC1E;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,2DAA2E;AAC/E;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,2DAAuE;AAC3E;;;AAGA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,2DAA8D;AAClE;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,4DAA4D;AAChE;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;IAC3B,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,mCAAmC;IACnC,kCAAkC;IAClC,kCAAkC;IAClC,wBAAwB;AAC5B;AACA;IACI,QAAQ;AACZ;;AAEA;IACI,SAAS;IACT,6CAA6C;AACjD","sourcesContent":["@font-face {\n    font-family: 'TT Hoves Pro Trial';\n    font-style: normal;\n    font-weight: 100;\n    font-display: swap;\n    src: url('@/shared/fonts/TT-Hoves-Pro-Trial-Thin.woff') format('woff');\n}\n@font-face {\n    font-family: 'TT Hoves Pro Trial';\n    font-style: normal;\n    font-weight: 200;\n    font-display: swap;\n    src: url('@/shared/fonts/TT-Hoves-Pro-Trial-ExtraLight.woff') format('woff');\n}\n\n@font-face {\n    font-family: 'TT Hoves Pro Trial';\n    font-style: normal;\n    font-weight: 300;\n    font-display: swap;\n    src: url('@/shared/fonts/TT-Hoves-Pro-Trial-Light.woff') format('woff');\n}\n\n@font-face {\n    font-family: 'TT Hoves Pro Trial';\n    font-style: normal;\n    font-weight: 400;\n    font-display: swap;\n    src: url('@/shared/fonts/TT-Hoves-Pro-Trial-Regular.woff') format('woff');\n}\n\n@font-face {\n    font-family: 'TT Hoves Pro Trial';\n    font-style: normal;\n    font-weight: 500;\n    font-display: swap;\n    src: url('@/shared/fonts/TT-Hoves-Pro-Trial-Medium.woff') format('woff');\n}\n\n@font-face {\n    font-family: 'TT Hoves Pro Trial';\n    font-style: normal;\n    font-weight: 600;\n    font-display: swap;\n    src: url('@/shared/fonts/TT-Hoves-Pro-Trial-DemiBold.woff') format('woff');\n}\n\n@font-face {\n    font-family: 'TT Hoves Pro Trial';\n    font-style: normal;\n    font-weight: 700;\n    font-display: swap;\n    src: url('@/shared/fonts/TT-Hoves-Pro-Trial-Bold.woff') format('woff');\n}\n\n@font-face {\n    font-family: 'TT Hoves Pro Trial';\n    font-style: normal;\n    font-weight: 800;\n    font-display: swap;\n    src: url('@/shared/fonts/TT-Hoves-Pro-Trial-ExtraBold.woff') format('woff');\n}\n\n@font-face {\n    font-family: 'TT Hoves Pro Trial';\n    font-style: normal;\n    font-weight: 900;\n    font-display: swap;\n    src: url(\"@/shared/fonts/TT-Hoves-Pro-Trial-Black.woff\") format('woff');\n}\n\n\n@font-face {\n    font-family: 'CeraPro';\n    font-style: normal;\n    font-weight: 400;\n    font-display: swap;\n    src: url(\"@/shared/fonts/CeraPro-Regular.woff\") format('woff');\n}\n\n@font-face {\n    font-family: 'CeraPro';\n    font-style: normal;\n    font-weight: 900;\n    font-display: swap;\n    src: url('@/shared/fonts/CeraPro-Black.woff') format('woff');\n}\n\n*{\n    box-sizing: border-box;\n    -webkit-touch-callout: none;\n    user-select: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    text-rendering: optimizeLegibility;\n    -ms-overflow-style: none;\n}\n*::-webkit-scrollbar{\n    width: 0;\n}\n\nbody {\n    margin: 0;\n    font-family: 'TT Hoves Pro Trial', sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
